






















import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { dateFormat } from '@/helpers/dateFormat';
import * as service from '@/services/dashboard';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ListMessages,
  },
})
export default class ProductionPrescriptionCharts extends BaseComponent {
  @Prop()
  public dateFrom: string;
  @Prop()
  public dateTo: string;
  @Prop()
  public idsBusinessUnits: number[];

  loading = false;
  error = false;

  public data: any = [];

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.getProductionPrescriptionChartData(filter);
        }),
      )
      .subscribe(
        (res) => {
          this.data = res;
          let total = 0;
          this.data.forEach((i) => (total += i.valor));
          this.data.push({ id: 'Total', valor: total });
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      );
      
    this.prepareLoad();
  }

  load() {
    let filtro = this.buildFiltro();
    this.execBehaviorSub$.next(filtro);
  }

  buildFiltro() {
    let filtro: any = {};
    filtro.dataDe = this.dateFrom ? dateFormat(this.dateFrom, 'US') : null;
    filtro.dataAte = this.dateTo ? dateFormat(this.dateTo, 'US') : null;
    filtro.idsEmpresas = this.idsBusinessUnits;

    return filtro;
  }

  @Watch('dateFrom')
  @Watch('dateTo')
  @Watch('idsBusinessUnits')
  public onChangeDates() {
    this.prepareLoad();
  }

  timeoutDatesChange = null;
  public prepareLoad() {
    clearTimeout(this.timeoutDatesChange);
    this.timeoutDatesChange = setTimeout(() => {
      this.load();
    }, 100);
  }
}
